var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
import { FILESPACE_ROOT_ID } from '../constants';
export const useMemFileBrowserStore = () => {
    _react_refresh_temp_1();
    const [currentDirId, setCurrentDirId] = useState(FILESPACE_ROOT_ID);
    return { currentDirId, setCurrentDirId };
};
_react_refresh_temp_1(useMemFileBrowserStore, "n/kjSsjboqfJWr/tl4DVTuJ8CmE=");
